import { KB } from '../productTypes'
import { selectCurrentPlanByType } from './selectCurrentPlanByType'

export const selectCurrentKb = state => {
  return selectCurrentPlanByType(state, KB)
}
